<template>
    <div class="scene">
        <div class="headline">{{ $t('headline.title7') }}</div>
        <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="logo">
                    <img :src="item" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                `https://4d-ai.chat/img/partner1.png`,
                `https://4d-ai.chat/img/partner2.png`,
                `https://4d-ai.chat/img/partner3.png`,
                `https://4d-ai.chat/img/partner4.png`,
                `https://4d-ai.chat/img/partner5.png`,
                `https://4d-ai.chat/img/partner6.png`,
                `https://4d-ai.chat/img/partner7.png`,
            ]
        }
    },
    mounted() {

    },
    methods: {}
}
</script>
<style scoped>
@media (max-width: 768px) {
    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .list {
        padding: 0 10px 10px !important;
    }

    .item {
        width: 100% !important;
        height: auto !important;
        margin: 0 0 10px !important;
        padding: 10px !important;
    }
}
</style>
<style scoped lang="less">
.list {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 0 212px 80px;
    box-sizing: border-box;

    .item:hover {
        box-shadow: 0 2px 50px #0000001a;
        transform: translate(0, -10px)
    }

    .item:nth-child(4n) {
        margin-right: 0;
    }

    .item {
        width: calc(25% - 22.5px);
        background-color: #fff;
        box-shadow: 0 2px 8px #0000001a;
        border-radius: 15px;
        overflow: hidden;
        box-sizing: border-box;
        transition: all 0.3s;
        margin-right: 30px;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 20px;

            img {
                width: 100%;
            }
        }

        .title {
            font-size: 20px;
            box-sizing: border-box;
            padding: 10px 0;
        }
    }
}

.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 34px;
}
</style>